import { Stack, Typography } from '@mui/material';
import { getRecommendations, IRecommendations } from 'API/Home/recommendations';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { useCallback, useEffect, useState } from 'react';
import { RecommendationCard } from './RecommendationCard';
import { MedicationList } from './RecommendationCard/RecoomendationInformation/MedicationList';

const MAX_RECOMMENDATIONS_VIEW = 3;

export const Recommendations = () => {
  const [recommendations, setRecommendations] = useState<IRecommendations[]>(
    []
  );
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const [showDialog, setShowDialog] = useState<JSX.Element | null>(null);

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Home
  ).userRecommendations;
  const isDesktop = useIsDesktop();

  const initRecommendations = useCallback(async () => {
    const recommendations = await getRecommendations();
    if (recommendations) setRecommendations(recommendations);
  }, []);

  useEffect(() => {
    initRecommendations();
  }, [initRecommendations, imposterId]);

  const removeRecommendation = (reqNumber: string) => {
    const filteredRecommendations = recommendations.filter((recommendation) => {
      return recommendation.entityJSON.items.every(
        (recommendationItem) =>
          Number(recommendationItem.reqNumber) !== Number(reqNumber)
      );
    });
    setRecommendations(filteredRecommendations);
  };

  if (recommendations.length === 0) return null;

  return (
    <Stack>
      <Typography variant='h5' component={'h2'}>
        {dictionary.title}
      </Typography>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap='24px'
        flexWrap='wrap'
        sx={{
          m: '12px 0',
        }}
      >
        {recommendations.map(
          (recommendationItem: IRecommendations, index: number) => {
            if (index >= MAX_RECOMMENDATIONS_VIEW) return null;
            let isHaveMedicationList = false;
            const title = recommendationItem.entityJSON.title;
            if (title === dictionary.openList) {
              isHaveMedicationList = true;
            }

            return (
              <RecommendationCard
                key={index}
                recommendationItem={recommendationItem}
                removeRecommendation={removeRecommendation}
                setShowDialog={
                  recommendationItem && isHaveMedicationList
                    ? () =>
                        setShowDialog(
                          <MedicationList data={recommendationItem} />
                        )
                    : undefined
                }
              />
            );
          }
        )}
      </Stack>
    </Stack>
  );
};
